import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import AbpBase from '@/lib/AbpBase';
var EditUser = /** @class */ (function (_super) {
    __extends(EditUser, _super);
    function EditUser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userRule = {
            userName: [{
                    required: true,
                    message: _this.L('FieldIsRequired', undefined, _this.L('UserName')),
                    trigger: 'blur'
                }],
            name: [{ required: true, message: _this.L('FieldIsRequired', undefined, _this.L('Name')), trigger: 'blur' }],
            surname: [{
                    required: true,
                    message: _this.L('FieldIsRequired', undefined, _this.L('Surname')),
                    trigger: 'blur'
                }],
            emailAddress: [{
                    required: true,
                    message: _this.L('FieldIsRequired', undefined, _this.L('Email')),
                    trigger: 'blur'
                },
                { type: 'email' }
            ],
            phoneNumber: [{
                    required: true,
                    message: _this.L('FieldIsRequired', undefined, _this.L('PhoneNumber')),
                    trigger: 'blur'
                }]
        };
        return _this;
    }
    Object.defineProperty(EditUser.prototype, "user", {
        get: function () {
            return this.$store.state.user.editUser;
        },
        enumerable: true,
        configurable: true
    });
    EditUser.prototype.created = function () {
    };
    Object.defineProperty(EditUser.prototype, "roles", {
        get: function () {
            return this.$store.state.user.roles;
        },
        enumerable: true,
        configurable: true
    });
    EditUser.prototype.save = function () {
        var _this = this;
        this.$refs.userForm.validate(function (valid) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!valid) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$store.dispatch({
                                type: 'user/update',
                                data: this.user
                            })];
                    case 1:
                        _a.sent();
                        this.$refs.userForm.resetFields();
                        this.$emit('save-success');
                        this.$emit('input', false);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    EditUser.prototype.cancel = function () {
        this.$refs.userForm.resetFields();
        this.$emit('input', false);
    };
    EditUser.prototype.visibleChange = function (value) {
        if (!value) {
            this.$refs.userForm.resetFields();
            this.$emit('input', value);
        }
    };
    __decorate([
        Prop({ type: Boolean, default: false })
    ], EditUser.prototype, "value", void 0);
    EditUser = __decorate([
        Component
    ], EditUser);
    return EditUser;
}(AbpBase));
export default EditUser;
